import SignalContent from "../signal_content";
import { MstSignallampComponentType, MstSignallampSettingType } from "../../../types/types";
import { RequestParamsController } from "../../../common/scripts/request_params_controller";

export class RequestSignallampParamsMaker {
  /**
   * コンポーネント設定情報取得処理用リクエストデータ生成処理。
   * @param {SignalContent} self
   * @param {string} userID
   * @returns リクエストデータ
   */
  public static makeGetSignallampComponentSettingDataParams(
    self: SignalContent,
    userID: string,
  ) {
    const data = {
      user_id: userID,
      signallamp_id: self.signallampID,
    };
    return RequestParamsController.create(
      "post",
      "getMstSignallampComponentSetting",
      data,
    );
  }

  /**
   * パトランプ設定情報取得処理用リクエストデータ生成処理。
   * @param {SignalContent} self
   * @param {string} userID
   * @returns リクエストデータ
   */
  public static makeGetSignallampSettingDataParams(
    self: SignalContent,
    userID: string
  ) {
    const data = {
      user_id: userID,
      signallamp_id: self.signallampID
    };
    return RequestParamsController.create(
      "post",
      "getMstSignallampSetting",
      data,
    );
  }

  /**
   * パトランプ センサーデータ取得処理用リクエストデータ生成処理。
   * Authストアから認証情報を取得し
   * @param {SignalContent} self
   * @param {string} userID
   * @param authStore
   * @param {string} deviceId
   * @returns リクエストデータ
   */
  public static makeGetSignallampSensorDataParams(
    self: SignalContent,
    userID: string,
    authStore: any,
    deviceId: string,
    mstSignallampSetting: any,
  ) {
    const data = {
      user_id: userID,
      signallamp_id: self.signallampID,
      mst_signallamp_setting_data: mstSignallampSetting,
      auth_store: authStore,
      device_id: deviceId,
    };
    return RequestParamsController.create("post", "getSignallampData", data);
  }

  /**
   * パトランプ センサーデータの過去8時間履歴を取得処理用リクエストデータ生成処理。
   * @param {SignalContent} self
   * @param {string} userID
   * @param authStore
   * @param {string} deviceId
   * @returns リクエストデータ
   */
  public static makeGetSignallampHistoryParams(
    self: SignalContent,
    userID: string,
    authStore: any,
    deviceId: string,
  ) {
    const data = {
      user_id: userID,
      signallamp_id: self.signallampID,
      mst_graph: self.mstSignallampSetting,
      auth_store: authStore,
      device_id: deviceId,
    };
    return RequestParamsController.create("post", "getSignallampHistory", data);
  }

  /**
   * パトランプ アラート履歴100件取得用リクエストデータ生成処理。
   * @param {SignalContent} self
   * @param {string} userID
   * @param authStore
   * @param {string} deviceId
   * @returns リクエストデータ
   */
  public static makeGetSignallampAlertParams(
    self: SignalContent,
  ) {
    const data = {
      mst_signallamp_setting_data: self.mstSignallampSetting,
      auth_store: self.authStore,
      deviceId: self.selectDeviceId
    };
    return RequestParamsController.create(
      "post",
      "getSignallampAlertHistory",
      data,
    );
  }

  /**
   * コンポーネント設定情報保存処理用リクエストデータ生成処理。
   * @param {SignalContent} self
   * @param {MstSignallampComponentType} updateData
   * @returns リクエストデータ
   */
  public static makeUpdateSignallampComponentSettingParams(
    updateData: MstSignallampComponentType,
  ) {
    return RequestParamsController.create(
      "post",
      "updateSignallampComponentSetting",
      updateData,
    );
  }

  /**
   * パトランプ設定(signallamp store)情報保存処理用リクエストデータ生成処理。
   * @param {MstSignallampSettingType} updateData
   * @returns リクエストデータ
   */
  public static makeUpdateSignallampSettingParams(updateData: any) {
    return RequestParamsController.create(
      "post",
      "updateSignallampSetting",
      updateData
    );
  }

  /**
   * パトランプ設定(signallamp store)情報削除処理用リクエストデータ生成処理。
   * @param {SignalContent} self
   * @param {MstSignallampSettingType} deleteData
   * @returns リクエストデータ
   */
  public static makeDeleteSignallampSettingParams(deviceID: any) {
    const deleteData = {
      device_id: deviceID
    };
    return RequestParamsController.create(
      "post",
      "deleteMstSignallampSetting",
      deleteData
    );
  }
}
